import S from './SingleDam.module.css';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import RateReviewIcon from '@mui/icons-material/RateReview';
import InfoIcon from '@mui/icons-material/Info';
import F from './AllFarmsAdmin.module.css'
import G from './ListDam.module.css'
import Stand from '../images/stand.svg'
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';import T from './AllFarmsAdmin.module.css'
import D from '../images/sensor.png'
import {   ChangeCircle, DateRangeRounded, Delete, DeleteForever, Edit, HorizontalSplitSharp, Key,ModelTrainingOutlined,PartyMode,Sell,Sensors, Settings, SplitscreenOutlined, TimelapseOutlined, TitleOutlined, TitleRounded } from '@mui/icons-material'
import StChartPacket from '../Components/StockChartPacket'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {  Link, useParams } from 'react-router-dom'
import { loginSuccessSensor } from '../redux/slices/singleSensorSlice'
import { useGlobalContext } from '../Components/Context'
import EditSens from '../Components/editModalSensor'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ReportIcon from '@mui/icons-material/Report';
import HistoryIcon from '@mui/icons-material/History';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import apiService from '../api/ApiService';
import Filter5Icon from '@mui/icons-material/Filter5';
import DangerousIcon from '@mui/icons-material/Dangerous';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ReplayIcon from '@mui/icons-material/Replay';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import NotificationsPausedIcon from '@mui/icons-material/NotificationsPaused';
import GrassIcon from '@mui/icons-material/Grass';
import MoveDownIcon from '@mui/icons-material/MoveDown';

import { Battery0Bar, DateRange } from '@mui/icons-material';
import DeleteComm from '../Components/deleteComment';
import SensorLogList from '../Components/cardThemes/SensorLogLists';
import CommentList from '../Components/cardThemes/CommentList';
import { addComments } from '../redux/slices/commentsSlice';
import EditComment from '../Components/editCattleComment';
import AddComment from '../Components/AddCattleComment';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { Pagination, Switch } from '@mui/material';
import { paginateCount } from '../api/helper';
import EmptyReturn from '../Components/EmptyReturn';
const moment=require('moment-jalaali');


const SingleSensor=()=>{
  const targetRef=useRef(null)
  const upRef=useRef(null);
  const downRef=useRef(null)
  const {currentTheme}=useSelector(state=>state.p.admin)
  const {currentTimeDiff}=useSelector(state=>state.p.time)
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null
  });
  const [selectedDayRange2, setSelectedDayRange2] = useState({
    from: null,
    to: null
  });
  const [total,setTotal]=useState(1)
    const [page1,setPage1]=useState(0)
  const {isModalCommentOpen,openModallComment,openModalls,isOpenModal,openD,closeD,opens,isModalEditCommentOpen,openEditModallComment}=useGlobalContext();
  const [hasmore,sethaseMore]=useState(true)
    const [result,setResult]=useState([]);
    const [selected,setSelected]=useState('')
    const [types,setTypes]=useState([])
    const [commentType,setCommentType]=useState(null)
    const [page,setPage]=useState(0)
    const {currentComments}=useSelector(state=>state.comments)
    const{currentSingleSensor}=useSelector(state=>state.singleSensor);
    const [commid,setCommid]=useState('')
    const {id}=useParams()
    const dispatch=useDispatch()
    const toggleSensor=async(id)=>{
      const res=await apiService.toggleSensor(id);
      dispatch(loginSuccessSensor(res.data));

    }
    const getComments=async()=>{
      let geregorian1=moment(`${selectedDayRange2.from?.year}-${selectedDayRange2.from?.month}-${selectedDayRange2.from?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
  
  
      let geregorian2=moment(`${selectedDayRange2.to?.year}-${selectedDayRange2.to?.month}-${selectedDayRange2.to?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
      const data=JSON.stringify({
          "skip": page?(page-1)*paginateCount:0,
          "take": paginateCount,
          "fromDate": selectedDayRange2.from?geregorian1:null,
            "toDate": selectedDayRange2.to?geregorian2:null,
          "sensorId": id,
          "sensorCommentTypeId": commentType
        })
      const res=await apiService.getSensorCommetns(data)
      dispatch(addComments(res.data.data))
      setTotal(Math.ceil(res.data.totalCount/paginateCount))

  }
  const getTypesSens=async()=>{
    const res=await apiService.getSensorComment();
    setTypes(res.data)

}
    const getDate=async()=>{
    const res=await apiService.getSensor(id)
    dispatch(loginSuccessSensor(res.data));
    }
    useEffect(()=>{
        getDate()
        getTypesSens()
    },[])
    useEffect(()=>{
      
        if(page==0){
          getComments()
        }
        setPage(0)
      
    },[selectedDayRange2.to,commentType])
    const getLogs=async()=>{
      let geregorian1=moment(`${selectedDayRange.from?.year}-${selectedDayRange.from?.month}-${selectedDayRange.from?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')


    let geregorian2=moment(`${selectedDayRange.to?.year}-${selectedDayRange.to?.month}-${selectedDayRange.to?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
      const data=JSON.stringify({
        "skip": page,
        "take": 25,
        "fromDate": selectedDayRange.from?geregorian1:null,
        "toDate": selectedDayRange.to?geregorian2:null
      })
      const res=await apiService.getSensorLogs(id,data)
      
      setResult((result)=>[...result,...res.data.data])
        if(res.data.data.length<1){
          sethaseMore(false)
        }
    }
   const handlePage=()=>{
          if(hasmore){
    setPage(page+25)

          }
   }
   const handlePage1 = (event, value) => {
    setPage1(value);
  };
   
    useEffect(()=>{
getLogs()
    },[page])
    useEffect(()=>{
      if(selectedDayRange.to!==null){
        if(page!==0){
          setPage(0)
        }
        setResult([])
        getLogs()
      }
    },[selectedDayRange.to])
    const renderCustomInput = ({ ref }) => (
      <>
        
        <input
      name="birth"
      autoComplete="off"
      ref={ref} // necessary
      placeholder='تاریخ تولد'
      value={selectedDayRange.from?`از ${selectedDayRange.from?.year}/${selectedDayRange.from?.month}/${selectedDayRange.from?.day}  تا  ${selectedDayRange.to?.year?selectedDayRange.to?.year:'-'}/${selectedDayRange.to?.month?selectedDayRange.to?.month:'-'}/${selectedDayRange.to?.day?selectedDayRange.to?.day:'-'}`:''}
      className="opop2" // a styling class
    />
    <label for="" class="labelSS9"><DateRangeRounded/> فیلتر بر اساس بازه زمانی </label>
    
      </>
    )
    const renderCustomInput2 = ({ ref }) => (
      <>
        
        <input
      name="birth"
      autoComplete="off"
      ref={ref} // necessary
      placeholder='تاریخ تولد'
      value={selectedDayRange2.from?`از ${selectedDayRange2.from?.year}/${selectedDayRange2.from?.month}/${selectedDayRange2.from?.day}  تا  ${selectedDayRange2.to?.year?selectedDayRange2.to?.year:'-'}/${selectedDayRange2.to?.month?selectedDayRange2.to?.month:'-'}/${selectedDayRange2.to?.day?selectedDayRange2.to?.day:'-'}`:''}
      className="opop2" // a styling class
    />
    <label for="" class="labelSS9"><DateRangeRounded/> فیلتر بر اساس بازه زمانی </label>
    
      </>
    )
    return <>
    <div className={S.SingleDamCon}>
    <div className='wraping' style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
    <div className={S.SingleDamTitleCon}>
        <img className={S.SingleDamimgTit} src={D}/>
        <h2 ref={upRef}>مشخصات سنسور</h2>
       
        </div>
        <div className='wraping'  style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div className={S.EditBtnTableDam}>
        <Link to={`/AllSensors/${id}/history`} data-title='  تاریخچه وضعیت'  >
                <HistoryIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </Link>
        </div>
            <div className={S.EditBtnTableDam}>
            <Link to={`/AllSensors/${id}/historyParameter`} data-title='  تاریخچه پارامتر'  >
                <ManageHistoryIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </Link>
            </div>
        <div data-title='لیست یادداشت ها' onClick={()=>targetRef.current.scrollIntoView({behavior:'smooth'})} className={S.EditBtnTableDam}>
                <SpeakerNotesIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
        
        <div onClick={openModalls} data-title='به روز رسانی' className={S.EditBtnTableDam}>
                <Edit sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
            </div>
    </div>
        <hr/>
        <div className={G.AnimContentLI}>
        <table >
            <thead>
            <tr>
            <th className={S.LogoFormT}><div><span>
                <ReportIcon/>
                </span>
                    </div></th>
                    <th className={S.LogoFormT}><div><span>
                <ReportIcon/>
                </span>
                    </div></th>
                    <th className={S.LogoFormT}><div><span>
                <Sell/>
                </span>
                    </div></th>
                
                    <th className={S.LogoFormT}><div><span><Sensors/></span></div></th>
                    
                    <th className={S.LogoFormT}><div><span>
                    <ModelTrainingOutlined/></span></div></th>
                    <th className={S.LogoFormT}><div><span>
                    <TimelapseOutlined/></span></div></th>
                    
                </tr>
            </thead>
            <tbody style={{margin:'0px auto'}}>
                
                <tr>
                <td className={S.TableFormTit}> وضعیت اتصال به دام</td>
                <td className={S.TableFormTit}> فعال/ غیر فعال  </td>
                <td className={S.TableFormTit}>شماره گردنبند</td>
                    <td className={S.TableFormTit}>کد دستگاه سنسور</td>
                    <td className={S.TableFormTit}> ورژن </td>
                    <td className={S.TableFormTit}>زمان ایجاد </td>
                    
                    
                </tr>
                <tr>
                <td>{currentSingleSensor&&currentSingleSensor?.sensorStatusId===0?'🟢':'🔴'}</td>  
                <td >
                <Switch color="success" checked={currentSingleSensor?.isActive} onChange={()=>toggleSensor(currentSingleSensor?.id)} />

                    </td>
                    <td>{currentSingleSensor?.necklaceNumber?currentSingleSensor?.necklaceNumber:'---'}</td>

                    <td>{currentSingleSensor?.deviceCode}</td>
                    <td>{currentSingleSensor?.version?currentSingleSensor?.version:'---'}</td>
                    <td>{moment(currentSingleSensor?.createAt).format('jYYYY-jMM-jDD HH:mm')}</td>
                    
                </tr>
               
            </tbody>
        </table>
        </div>
        <div className='specsss' style={{display:'flex',gap:'30px',textAlign:'center',alignItems:'center',borderRight:'3px solid green' ,marginTop:'16px'}}>
          <div className='d-flex gap-1 align-items-center '>
          <div className='LogoFormT'>
          <div ><span>
                <Settings/>
                </span>
                    </div>
          </div>
                    <div className={S.TableFormTit}>   مشخصات </div>

          </div>
          <div>{currentSingleSensor?.specs}</div>
        </div>
        <div className={S.StChartCon}>
            <h2>Sensor Logs
</h2>
            <StChartPacket stats={result}/></div>
            <div class="inputContainerSS">
                           <DatePicker
                           value={selectedDayRange}
                           onChange={setSelectedDayRange}
                             locale='fa'
                             calendarClassName="birthCalender"
                             renderInput={renderCustomInput}
                             />
                             
                           
                              
                       </div>
            {!currentTheme&&<div className={`contScroll ${T.AnimContentLI}`} data-aos='fade'>
          <table>
              <thead>
              <tr>
                  <th>
                  <div className='LogoFormT'><div><span>
                <SplitscreenOutlined/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Filter5Icon/>
                </span>
                    </div></div>
                  </th>
                  
                  
                  
                  <th>
                  <div className='LogoFormT'><div><span>
                <Battery0Bar/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <WaterDropIcon/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <DeviceThermostatIcon/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <TrendingUpIcon/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <StackedLineChartIcon/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <GrassIcon/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <GrassIcon/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <NotificationsPausedIcon/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
            <img style={{width:'20px',height:'20px'}}  src={Stand} width={20} height={20}/> 
                </span>
                    </div></div>
                  </th>
                  
                  <th>
                  <div className='LogoFormT'><div><span>
                <MoveDownIcon/>
                </span>
                    </div></div> 
                  </th>
                  
                  
                  
                  {/* <th>
                    detail
                  </th> */}
                </tr>
                <tr>
                  <th>
                    index
                  </th>
                  <th>
                    logTime
                  </th>
                  <th>
                       packetCounter
                  </th>
                  
                  
                  
                  <th>
                      batteryLevel
                  </th>
                  <th>
                     humidity
                  </th>
                  <th>
                       temperature
                  </th>
                  <th>
                       activity
                  </th>
                  <th>
                        unrest
                  </th>
                  <th>
                      chewing
                  </th>
                  <th>
                     rumination
                  </th>
                  <th>
                    sleeping
                  </th>
                  <th>
                    standing
                  </th>
                  
                  <th>
                      walking 
                  </th>
                  
                  
                  
                  {/* <th>
                    detail
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {
                  result?.map((item,index)=>{
                    const {logTime}=item;
   const day=moment(logTime).format(`jYYYY/jMM/jDD HH:mm`)
                    return <tr key={index}>
                    <td>
                      {index+1}
                    </td>
                    <td>
                      {`(${day})`}
                    </td>
                    <td>
                      {item.packetCounter}
                    </td>
                    <td>
                      {item.batteryLevel}
                    </td>
                    <td>
                      {item.humidity}
                    </td>
                    <td>
                        {item.temperature}
                    </td>
                    <td>
                        {item.activity}
                    </td>
                    <td>
                        {item.unrest}
                    </td>
                    <td>
                      {item.chewing}
                    </td>
                    <td>
                      {item.rumination}
                    </td>
                    <td>
                      {item.sleeping}
                    </td>
                    <td>
                      {
                        item.standing
                      }
                    </td>
                    <td>
                      {item.walking}
                    </td>
                  </tr>
                  
                  })
                }

              </tbody>
            </table>
          </div>}
          {currentTheme&&<SensorLogList data={result}/>}
{hasmore&&<div  className='AddIConTotheList'>
  <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }} className='AddIconToTheListmain' onClick={handlePage}/>
</div>
}
<div className='wraping' style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
    <div className={S.SingleDamTitleCon}>
        <img className={S.SingleDamimgTit} src={D}/>
        <h2 ref={targetRef}>یادداشت های سنسور</h2>
        </div>
        <div ref={downRef} style={{display:'flex',gap:'10px',}}>
       
        <div title='افزودن یادداشت' className={S.EditBtnTableDam} onClick={openModallComment}> 
                <RateReviewIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
        
            </div>
    </div>
        <hr/>
        <div style={{width:'100%',direction:'ltr'}} className='d-flex justify-content-between'>
        <select style={{direction:'rtl',alignSelf:'end'}}   id='sele'  name='sele' className={`selectInp ${G.selectStyle}`} value={commentType} onChange={(e)=>setCommentType(e.target.value)} >
    <option  value={'null'} >همه</option>
                {types?.length&&types.map((item,index)=>{
                                         return <option key={index}  value={item?.id}>{item?.title} {item?.count}</option>
                
                            })}
                            
                       
                    </select>
                    <div class="inputContainerSS">
                           <DatePicker
                           value={selectedDayRange2}
                           onChange={setSelectedDayRange2}
                             locale='fa'
                             calendarClassName="birthCalender"
                             renderInput={renderCustomInput2}
                             />
                             
                           
                              
                       </div>
    </div>
{
  !currentTheme&&currentComments?.length?<div  className={F.AnimContentLI} style={{borderTopLeftRadius:0}} data-aos='fade'>
  <table >
      <thead>
      <tr>
          <th>
          <div className='LogoFormT'><div><span>
                <SplitscreenOutlined/>
                </span>
                    </div></div>          </th>
          <th>
          <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
          </th>
          <th>
          <div className='LogoFormT'><div><span>
                <TitleOutlined/>
                </span>
                    </div></div>
          </th>
          <th>
          <div className='LogoFormT'><div><span>
                <TitleRounded/>
                </span>
                    </div></div>
          </th>
          <th>
          <div className='LogoFormT'><div><span>
                <HorizontalSplitSharp/>
                </span>
                    </div></div>
          </th>
          <th>
          <div className='LogoFormT'><div><span>
                <DeleteForever/>
                </span>
                    </div></div>
          </th>
          <th>
          <div className='LogoFormT'><div><span>
                <InfoIcon/>
                </span>
                    </div></div>
          </th>
          
        </tr>
        <tr>
          <th>
            ردیف
          </th>
          <th>
             زمان
          </th>
          <th>
             موضوع
          </th>
          <th>
             متن
          </th>
          <th>
             دسته
          </th>
          <th>
             حذف
          </th>
          <th>
             جزئیات
          </th>
          
        </tr>
      </thead>
      <tbody>
        {
          currentComments?.map((item,index)=>{
            const {entryDate}=item;
                    const pbirth=moment(entryDate).format('jYYYY-jMM-jDD HH:mm')
            return <tr key={index}>
            <td>
              {index+1}
            </td>
            <td>
              {pbirth}
            </td>
            <td>
              {item?.title?.substring(0,15)}
            </td>
            <td>
              {item?.comment?.substring(0,25)}
            </td>
            <td>
              {item.sensorCommentTypeTitle}
            </td>
            <td onClick={()=>{setCommid(item.id);openD()}}>
            <div className='deldel' > <Delete/></div>
            </td>
            <td className={F.DetIc}>
              <div onClick={()=>{openEditModallComment();setSelected(item)}}>
              <div  className='btnCardDAm'>مشاهده</div>
              </div>
            </td>
          </tr>
          
          })
        }

      </tbody>
    </table>
    
  </div>:!currentTheme&&<EmptyReturn/>
}
<div style={{display:'flex',flexDirection:'column'}}>
<div>
<div onClick={()=>upRef.current.scrollIntoView({behavior:'smooth'})} className='Gotop'>
  <ArrowUpwardIcon/>
</div>
</div>
<div>
<div onClick={()=>downRef.current.scrollIntoView({behavior:'smooth'})} className='Gotop2'>
  <ArrowDownwardIcon/>
</div>
</div>
</div>
    </div>
    
    {currentTheme&&<CommentList flag={'sensor'}/>}
    <div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page1==0?page1+1:page1} onChange={handlePage1} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
    {isOpenModal&&<EditSens  penr={currentSingleSensor}/>}
    {isModalCommentOpen&&<AddComment flag={"sensor"} />}
    {!currentTheme&&isModalEditCommentOpen&&<EditComment types={types}  selected={selected} flag={"sensor"}/>}
    {!currentTheme&&opens&&<DeleteComm penr={commid} type={"sensor"}/>}
    </>
}

export default SingleSensor;